require.register("modules/m0x/a05/page-53a/page-53a", function(exports, require, module){
  var BaseExtension = require('base-extension');
var _ = window._ || require('lodash');

var page_53a = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {
    onComplete();
  }
}, BaseExtension);

module.exports = page_53a;


  
});

